import React, { useEffect } from "react";
import { Grid, Select, MenuItem } from "@material-ui/core";
// import MinAndMaxLength from "./common/MinAndMaxLength";
import NumberColumnOptions from "./common/NumberColumnOptions";

const currencyTypeOptions = [
  {
    name: "United States Dollar - USD",
    val: "United States Dollar - USD",
    symbol: "$",
    code: "USD",
    symbol2: "",
  },
  {
    name: "India Rupee - INR",
    val: "India Rupee - INR",
    symbol: "₹",
    code: "INR",
    symbol2: "Rs.",
  },
  {
    name: "Euro Member Countries - EUR",
    val: "Euro Member Countries - EUR",
    symbol: "€",
    symbol2: "",
    code: "EUR",
  },
  {
    name: "Albania Lek - ALL",
    val: "Albania Lek - ALL",
    symbol: "Lek",
    symbol2: "",
    code: "ALL",
  },
  {
    name: "Afghanistan Afghani - AFN",
    val: "Afghanistan Afghani - AFN",
    symbol: "\u060B",
    symbol2: "",
    code: "AFN",
  },
  {
    name: "Argentina Peso - ARS",
    val: "Argentina Peso - ARS",
    symbol: "$",
    symbol2: "",
    code: "ARS",
  },
  {
    name: "Aruba Guilder - AWG",
    val: "Aruba Guilder - AWG",
    symbol: "ƒ",
    symbol2: "",
    code: "AWG",
  },
  {
    name: "Azerbaijan New Manat - AZN",
    val: "Azerbaijan New Manat - AZN",
    symbol: "ман",
    symbol2: "",
    code: "AZN",
  },
  {
    name: "Australia Dollar - AUD",
    val: "Australia Dollar - AUD",
    symbol: "$",
    symbol2: "",
    code: "AUD",
  },
  {
    name: "Bahamas Dollar - BSD",
    val: "Bahamas Dollar - BSD",
    symbol: "$",
    symbol2: "",
    code: "BSD",
  },
  {
    name: "Barbados Dollar - BBD",
    val: "Barbados Dollar - BBD",
    symbol: "$",
    symbol2: "",
    code: "BBD",
  },
  {
    name: "Belarus Ruble - BYR",
    val: "Belarus Ruble - BYR",
    symbol: "p.",
    symbol2: "",
    code: "BYR",
  },
  {
    name: "Belize Dollar - BZD",
    val: "Belize Dollar - BZD",
    symbol: "BZ$",
    symbol2: "",
    code: "BZD",
  },
  {
    name: "Bermuda Dollar - BMD",
    val: "Bermuda Dollar - BMD",
    symbol: "$",
    symbol2: "",
    code: "BMD",
  },
  {
    name: "Bolivia Bolíviano - BOB",
    val: "Bolivia Bolíviano - BOB",
    symbol: "$b",
    symbol2: "",
    code: "BOB",
  },
  {
    name: "Bosnia and Herzegovina Convertible Marka - BAM",
    val: "Bosnia and Herzegovina Convertible Marka - BAM",
    symbol: "KM",
    symbol2: "",
    code: "BAM",
  },
  {
    name: "Botswana Pula - BWP",
    val: "Botswana Pula - BWP",
    symbol: "P",
    symbol2: "",
    code: "BWP",
  },
  {
    name: "Bulgaria Lev - BGN",
    val: "Bulgaria Lev - BGN",
    symbol: "лв",
    symbol2: "",
    code: "BGN",
  },
  {
    name: "Brazil Real - BRL",
    val: "Brazil Real - BRL",
    symbol: "R$",
    symbol2: "",
    code: "BRL",
  },
  {
    name: "Brunei Darussalam Dollar - BND",
    val: "Brunei Darussalam Dollar - BND",
    symbol: "$",
    symbol2: "",
    code: "BND",
  },
  {
    name: "Cambodia Riel - KHR",
    val: "Cambodia Riel - KHR",
    symbol: "\u17DB",
    symbol2: "",
    code: "KHR",
  },
  {
    name: "Canada Dollar - CAD",
    val: "Canada Dollar - CAD",
    symbol: "$",
    symbol2: "",
    code: "CAD",
  },
  {
    name: "Cayman Islands Dollar - KYD",
    val: "Cayman Islands Dollar - KYD",
    symbol: "$",
    symbol2: "",
    code: "KYD",
  },
  {
    name: "Chile Peso - CLP",
    val: "Chile Peso - CLP",
    symbol: "$",
    symbol2: "",
    code: "CLP",
  },
  {
    name: "China Yuan Renminbi - CNY",
    val: "China Yuan Renminbi - CNY",
    symbol: "¥",
    symbol2: "",
    code: "CNY",
  },
  {
    name: "Colombia Peso - COP",
    val: "Colombia Peso - COP",
    symbol: "$",
    symbol2: "",
    code: "COP",
  },
  {
    name: "Costa Rica Colon - CRC",
    val: "Costa Rica Colon - CRC",
    symbol: "₡",
    symbol2: "",
    code: "CRC",
  },
  {
    name: "Croatia Kuna - HRK",
    val: "Croatia Kuna - HRK",
    symbol: "kn",
    symbol2: "",
    code: "HRK",
  },
  {
    name: "Cuba Peso - CUP",
    val: "Cuba Peso - CUP",
    symbol: "₱",
    symbol2: "",
    code: "CUP",
  },
  {
    name: "Czech Republic Koruna - CZK",
    val: "Czech Republic Koruna - CZK",
    symbol: "Kč",
    symbol2: "",
    code: "CZK",
  },
  {
    name: "Denmark Krone - DKK",
    val: "Denmark Krone - DKK",
    symbol: "kr",
    symbol2: "",
    code: "DKK",
  },
  {
    name: "Dominican Republic Peso - DOP",
    val: "Dominican Republic Peso - DOP",
    symbol: "RD$",
    symbol2: "",
    code: "DOP",
  },
  {
    name: "East Caribbean Dollar	- XCD",
    val: "East Caribbean Dollar	- XCD",
    symbol: "$",
    symbol2: "",
    code: "XCD",
  },
  {
    name: "Egypt Pound - EGP",
    val: "Egypt Pound - EGP",
    symbol: "£",
    code: "EGP",
  },
  {
    name: "Euro Member Countries	- EUR",
    val: "Euro Member Countries - EUR",
    symbol: "€",
    symbol2: "",
    code: "EUR",
  },
  {
    name: "Falkland Islands (Malvinas) Pound - FKP",
    val: "Falkland Islands (Malvinas) Pound - FKP",
    symbol: "£",
    symbol2: "",
    code: "FKP",
  },
  {
    name: "Fiji Dollar - FJD",
    val: "Fiji Dollar - FJD",
    symbol: "$",
    symbol2: "",
    code: "FJD",
  },
  {
    name: "Ghana Cedi - GHS",
    val: "Ghana Cedi - GHS",
    symbol: "¢",
    symbol2: "",
    code: "GHS",
  },
  {
    name: "Gibraltar Pound - GIP",
    val: "Gibraltar Pound - GIP",
    symbol: "£",
    symbol2: "",
    code: "GIP",
  },
  {
    name: "Guatemala Quetzal - GTQ",
    val: "Guatemala Quetzal - GTQ",
    symbol: "Q",
    symbol2: "",
    code: "GTQ",
  },
  {
    name: "Guernsey Pound - GGP",
    val: "Guernsey Pound - GGP",
    symbol: "£",
    symbol2: "",
    code: "GGP",
  },
  {
    name: "Guyana Dollar	- GYD",
    val: "Guyana Dollar - GYD",
    symbol: "$",
    symbol2: "",
    code: "GYD",
  },
  {
    name: "Honduras Lempira - HNL",
    val: "Honduras Lempira - HNL",
    symbol: "L",
    symbol2: "",
    code: "HNL",
  },
  {
    name: "Hong Kong Dollar - HKD",
    val: "Hong Kong Dollar - HKD",
    symbol: "$",
    symbol2: "",
    code: "HKD",
  },
  {
    name: "Hungary Forint - HUF",
    val: "Hungary Forint - HUF",
    symbol: "Ft",
    symbol2: "",
    code: "HUF",
  },
  {
    name: "Iceland Krona - ISK",
    val: "Iceland Krona - ISK",
    symbol: "kr",
    symbol2: "",
    code: "ISK",
  },
  {
    name: "Indonesia Rupiah - IDR",
    val: "Indonesia Rupiah - IDR",
    symbol: "Rp",
    symbol2: "",
    code: "IDR",
  },
  {
    name: "Iran Rial - IRR",
    val: "Iran Rial - IRR",
    symbol: "\uFDFC",
    symbol2: "",
    code: "IRR",
  },
  {
    name: "Isle of Man Pound  - IMP",
    val: "Isle of Man Pound  - IMP",
    symbol: "£",
    symbol2: "",
    code: "IMP",
  },
  {
    name: "Israel Shekel - ILS",
    val: "Israel Shekel - ILS",
    symbol: "₪",
    symbol2: "",
    code: "ILS",
  },
  {
    name: "Jamaica Dollar - JMD",
    val: "Jamaica Dollar - JMD",
    symbol: "J$",
    symbol2: "",
    code: "JMD",
  },
  {
    name: "Japan Yen - JPY",
    val: "Japan Yen - JPY",
    symbol: "¥",
    symbol2: "",
    code: "JPY",
  },
  {
    name: "Jersey Pound - JEP",
    val: "Jersey Pound - JEP",
    symbol: "£",
    symbol2: "",
    code: "JEP",
  },
  {
    name: "Kazakhstan Tenge - KZT",
    val: "Kazakhstan Tenge - KZT",
    symbol: "лв",
    symbol2: "",
    code: "KZT",
  },
  {
    name: "Korea (North) Won - KPWD",
    val: "Korea (North) Won - KPWD",
    symbol: "₩",
    symbol2: "",
    code: "KPWD",
  },
  {
    name: "Korea (South) Won - KRW",
    val: "Korea (South) Won - KRW",
    symbol: "₩",
    symbol2: "",
    code: "KRW",
  },
  {
    name: "Kyrgyzstan Som - KGS",
    val: "Kyrgyzstan Som - KGS",
    symbol: "лв",
    symbol2: "",
    code: "KGS",
  },
  {
    name: "Laos Kip - LAK",
    val: "Laos Kip - LAK",
    symbol: "лв",
    symbol2: "₭",
    code: "LAK",
  },
  {
    name: "Lebanon Pound - LBP",
    val: "Lebanon Pound - LBP",
    symbol: "£",
    symbol2: "",
    code: "LBP",
  },
  {
    name: "Liberia Dollar - LRD",
    val: "Liberia Dollar - LRD",
    symbol: "$",
    symbol2: "",
    code: "LRD",
  },
  {
    name: "Macedonia Denar - MKD",
    val: "Macedonia Denar - MKD",
    symbol: "ден",
    symbol2: "",
    code: "MKD",
  },
  {
    name: "Malaysia Ringgit - MYR",
    val: "Malaysia Ringgit - MYR",
    symbol: "RM",
    symbol2: "",
    code: "MYR",
  },
  {
    name: "Mauritius Rupee - MUR",
    val: "Mauritius Rupee - MUR",
    symbol: "Rs",
    symbol2: "",
    code: "MUR",
  },
  {
    name: "Mexico Peso - MXN",
    val: "Mexico Peso - MXN",
    symbol: "$",
    symbol2: "",
    code: "MXN",
  },
  {
    name: "Mongolia Tughrik - MNT",
    val: "Mongolia Tughrik - MNT",
    symbol: "₮",
    symbol2: "",
    code: "MNT",
  },
  {
    name: "Mozambique Metical - MZN",
    val: "Mozambique Metical - MZN",
    symbol: "MT",
    symbol2: "",
    code: "MZN",
  },
  {
    name: "Namibia Dollar - NAD",
    val: "Namibia Dollar - NAD",
    symbol: "$",
    symbol2: "",
    code: "NAD",
  },
  {
    name: "Nepal Rupee - NPR",
    val: "Nepal Rupee - NPR",
    symbol: "₨",
    symbol2: "",
    code: "NPR",
  },
  {
    name: "Netherlands Antilles Guilder - ANG",
    val: "Netherlands Antilles Guilder - ANG",
    symbol: "ƒ",
    symbol2: "",
    code: "ANG",
  },
  {
    name: "New Zealand Dollar - NZD",
    val: "New Zealand Dollar - NZD",
    symbol: "$",
    symbol2: "",
    code: "NZD",
  },
  {
    name: "Nicaragua Cordoba - NIO",
    val: "Nicaragua Cordoba - NIO",
    symbol: "C$",
    symbol2: "",
    code: "NIO",
  },
  {
    name: "Nigeria Naira - NGN",
    val: "Nigeria Naira - NGN",
    symbol: "₦",
    symbol2: "",
    code: "NGN",
  },
  {
    name: "Korea (North) Won - KPW",
    val: "Korea (North) Won - KPW",
    symbol: "₩",
    symbol2: "",
    code: "KPW",
  },
  {
    name: "Norway Krone - NOK",
    val: "Norway Krone - NOK",
    symbol: "kr",
    symbol2: "",
    code: "NOK",
  },
  {
    name: "Oman Rial - OMR",
    val: "Oman Rial - OMR",
    symbol: "\uFDFC",
    symbol2: "",
    code: "OMR",
  },
  {
    name: "Pakistan Rupee - PKR",
    val: "Pakistan Rupee - PKR",
    symbol: "₨",
    symbol2: "",
    code: "PKR",
  },
  {
    name: "Panama Balboa	- PAB",
    val: "Panama Balboa - PAB",
    symbol: "B/.",
    symbol2: "",
    code: "PAB",
  },
  {
    name: "Paraguay Guarani - PYG",
    val: "Paraguay Guarani - PYG",
    symbol: "Gs",
    symbol2: "",
    code: "PYG",
  },
  {
    name: "Peru Sol - PEN",
    val: "Peru Sol - PEN",
    symbol: "S/.",
    symbol2: "",
    code: "PEN",
  },
  {
    name: "Philippines Peso - PHP",
    val: "Philippines Peso - PHP",
    symbol: "₱",
    symbol2: "",
    code: "PHP",
  },
  {
    name: "Poland Zloty - PLN",
    val: "Poland Zloty - PLN",
    symbol: "zł",
    symbol2: "",
    code: "PLN",
  },
  {
    name: "Qatar Riyal - QAR",
    val: "Qatar Riyal - QAR",
    symbol: "\uFDFC",
    symbol2: "",
    code: "QAR",
  },
  {
    name: "Romania New Leu - RON",
    val: "Romania New Leu - RON",
    symbol: "lei",
    symbol2: "",
    code: "RON",
  },
  {
    name: "Russia Ruble - RUB",
    val: "Russia Ruble - RUB",
    symbol: "руб",
    symbol2: "",
    code: "RUB",
  },
  {
    name: "Saint Helena Pound - SHP",
    val: "Saint Helena Pound - SHP",
    symbol: "£",
    symbol2: "",
    code: "SHP",
  },
  {
    name: "Saudi Arabia Riyal - SAR",
    val: "Saudi Arabia Riyal - SAR",
    symbol: "\uFDFC",
    symbol2: "",
    code: "SAR",
  },
  {
    name: "Serbia Dinar - RSD",
    val: "Serbia Dinar - RSD",
    symbol: "Дин.",
    symbol2: "",
    code: "RSD",
  },
  {
    name: "Seychelles Rupee - SCR",
    val: "Seychelles Rupee - SCR",
    symbol: "₨",
    symbol2: "",
    code: "SCR",
  },
  {
    name: "Singapore Dollar - SGD",
    val: "Singapore Dollar - SGD",
    symbol: "$",
    symbol2: "",
    code: "SGD",
  },
  {
    name: "Solomon Islands Dollar - SBD",
    val: "Solomon Islands Dollar - SBD",
    symbol: "$",
    symbol2: "",
    code: "SBD",
  },
  {
    name: "Somalia Shilling - SOS",
    val: "Somalia Shilling - SOS",
    symbol: "S",
    symbol2: "",
    code: "SOS",
  },
  {
    name: "South Africa Rand - ZAR",
    val: "South Africa Rand - ZAR",
    symbol: "R",
    symbol2: "",
    code: "ZAR",
  },
  {
    name: "Sri Lanka Rupee - LKR",
    val: "Sri Lanka Rupee - LKR",
    symbol: "₨",
    symbol2: "",
    code: "LKR",
  },
  {
    name: "Sweden Krona - SEK",
    val: "Sweden Krona - SEK",
    symbol: "kr",
    symbol2: "",
    code: "SEK",
  },
  {
    name: "Switzerland Franc - CHF",
    val: "Switzerland Franc - CHF",
    symbol: "CHF",
    symbol2: "",
    code: "CHF",
  },
  {
    name: "Suriname Dollar - SRD",
    val: "Suriname Dollar - SRD",
    symbol: "$",
    symbol2: "",
    code: "SRD",
  },
  {
    name: "Syria Pound - SYP",
    val: "Syria Pound - SYP",
    symbol: "£",
    symbol2: "",
    code: "SYP",
  },
  {
    name: "Taiwan New Dollar - TWD",
    val: "Taiwan New Dollar - TWD",
    symbol: "NT$",
    symbol2: "",
    code: "TWD",
  },
  {
    name: "Thailand Baht - THB",
    val: "Thailand Baht - THB",
    symbol: "฿",
    symbol2: "",
    code: "THB",
  },
  {
    name: "Trinidad and Tobago Dollar - TTD",
    val: "Trinidad and Tobago Dollar - TTD",
    symbol: "TT$",
    symbol2: "",
    code: "TTD",
  },
  {
    name: "Turkey Lira - TRY",
    val: "Turkey Lira - TRY",
    symbol: "\u20BA",
    symbol2: "",
    code: "TRY",
  },
  {
    name: "Tuvalu Dollar - TVD",
    val: "Tuvalu Dollar - TVD",
    symbol: "$",
    symbol2: "",
    code: "TVD",
  },
  {
    name: "Ukraine Hryvnia - UAH",
    val: "Ukraine Hryvnia - UAH",
    symbol: "₴",
    symbol2: "",
    code: "UAH",
  },
  {
    name: "United Kingdom Pound - GBP",
    val: "United Kingdom Pound - GBP",
    symbol: "£",
    symbol2: "",
    code: "GBP",
  },
  {
    name: "Uruguay Peso - UYU",
    val: "Uruguay Peso - UYU",
    symbol: "$U",
    symbol2: "",
    code: "UYU",
  },
  {
    name: "Uzbekistan Som - UZS",
    val: "Uzbekistan Som - UZS",
    symbol: "лв",
    symbol2: "",
    code: "UZS",
  },
  {
    name: "Venezuela Bolivar - VEF",
    val: "Venezuela Bolivar - VEF",
    symbol: "Bs",
    symbol2: "",
    code: "VEF",
  },
  {
    name: "Viet Nam Dong	- VND",
    val: "Viet Nam Dong	- VND",
    symbol: "₫",
    symbol2: "",
    code: "VND",
  },
  {
    name: "Yemen Rial - YER",
    val: "Yemen Rial - YER",
    symbol: "\uFDFC",
    symbol2: "",
    code: "YER",
  },
  {
    name: "Zimbabwe Dollar - ZWD",
    val: "Zimbabwe Dollar - ZWD",
    symbol: "Z$",
    symbol2: "",
    code: "ZWD",
  },
];

const getCurrencyFormats = function (code, symbol, symbol2) {
  if (symbol2 !== "") {
    return [
      { name: symbol + "1,000", val: symbol, atEnd: false },
      {
        name: code + " " + symbol + "1,000",
        val: code + " " + symbol,
        atEnd: false,
      },
      { name: "1,000" + symbol, val: symbol + "_atEnd", atEnd: true },
      { name: symbol2 + "1,000", val: symbol2, atEnd: false },
      {
        name: code + " " + symbol2 + "1,000",
        val: code + " " + symbol2,
        atEnd: false,
      },
      { name: "1,000" + symbol2, val: symbol2 + "_atEnd", atEnd: true },
    ];
  }
  return [
    { name: symbol + "1,000", val: symbol, atEnd: false },
    {
      name: code + " " + symbol + "1,000",
      val: code + " " + symbol,
      atEnd: false,
    },
    { name: "1,000" + symbol, val: symbol + "_atEnd", atEnd: true },
  ];
};

function CurrencyColumnConfig(props) {
  const { values, setFieldValue, valuesPath = "" } = props;

  useEffect(() => {
    if (values.options.currency_type) {
      return;
    }
    setFieldValue(
      `${valuesPath}options.currency_type`,
      "United States Dollar - USD"
    );
    setFieldValue(`${valuesPath}options.currency_symbol`, "$");
    setFieldValue(`${valuesPath}options.currency_code`, "USD");
  }, [setFieldValue, values.options.currency_type, valuesPath]);

  const currencyType = currencyTypeOptions.find(
    (x) => x.val === values.options.currency_type
  );

  if (!currencyType) {
    return null;
  }

  const currencyFormats = getCurrencyFormats(
    currencyType.code,
    currencyType.symbol,
    currencyType.symbol2
  );

  let currencySymbol = values.options.currency_symbol;
  if (values.options.symbol_at_end) {
    currencySymbol = currencySymbol + "_atEnd";
  }

  return (
    <>
      <Grid item container xs={12}>
        Currency Type:
        <Grid item xs={12}>
          <Select
            name={`${valuesPath}options.currency_type`}
            value={values.options.currency_type ?? ""}
            onChange={(ev) => {
              const item = currencyTypeOptions.find(
                (i) => i.val === ev.target.value
              );
              setFieldValue(
                `${valuesPath}options.currency_type`,
                ev.target.value
              );
              setFieldValue(
                `${valuesPath}options.currency_symbol`,
                item.symbol
              );
              setFieldValue(
                `${valuesPath}options.currency_code`,
                item.code
              );
            }}
            variant="outlined"
            style={{ width: 200 }}
          >
            {currencyTypeOptions.map((option) => (
              <MenuItem value={option.val}>{option.name}</MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
      <Grid item container xs={12}>
        Format:
        <Grid item xs={12}>
          <Select
            name={`${valuesPath}options.currency_type`}
            value={currencySymbol}
            onChange={(ev) => {
              let format = ev.target.value,
                symbolAtEnd = false;

              if (format.indexOf("_atEnd") !== -1) {
                format = format.split("_atEnd");
                format = format[0];
                symbolAtEnd = true;
              }

              setFieldValue(`${valuesPath}options.currency_symbol`, format);
              setFieldValue(`${valuesPath}options.symbol_at_end`, symbolAtEnd);
            }}
            variant="outlined"
            style={{ width: 200 }}
          >
            {currencyFormats.map((option) => (
              <MenuItem value={option.val}>{option.name}</MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
      <NumberColumnOptions {...props} />
    </>
  );
}

export default CurrencyColumnConfig;